export default __webpack_public_path__ + "static/media/historyIcon.c14be6f8.png";